import {
    consoleLogHandler,
    getSearchParams,
    historyLogHandler,
    initializeLogging as initializeVinylLogging,
    LogLevel,
    parseLogLevel,
} from '@amazon/vinyl-util'
import { debug } from '@/core/debug'

export function initializeLogging() {
    initializeVinylLogging()
    const logLevelParam = getSearchParams().get('logLevel')
    if (logLevelParam || debug) {
        const cLH = consoleLogHandler.value
        const hLH = historyLogHandler.value
        const logLevel: LogLevel = parseLogLevel(logLevelParam ?? 'debug') ?? LogLevel.DEBUG
        if (cLH) cLH.logLevel = logLevel
        if (hLH) hLH.logLevel = logLevel
    }
}
